export default __webpack_public_path__ + "static/media/beeFlower.932dbb2c.jpg";